import { useCallback, useState } from "react";
import moment from "moment";

import useLocationQueryParams from "./useLocationQueryParams";
import { searchParcel } from "../services/parcel";
import { DATE_FORMAT, API_DATE_FORMAT } from "../utils/query";
import { removeSpecialCharacters } from "../utils/string";

export default () => {
  const { date } = useLocationQueryParams();
  const [foundParcels, setFoundParcels] = useState(null);

  const handleReset = useCallback(() => {
    setFoundParcels(null);
  }, []);

  const handleSearch = useCallback(
    async ({ parcelNumber }) => {
      const formatParcelNumber = removeSpecialCharacters(parcelNumber).trim();
      try {
        const timestamp = moment(date, DATE_FORMAT).format(API_DATE_FORMAT);
        const result = await searchParcel(formatParcelNumber, timestamp);
        setFoundParcels(result);
      } catch {
        setFoundParcels([]);
      }
    },
    [date]
  );

  return [foundParcels, handleReset, handleSearch];
};
